<template>
  <v-row justify="center">
    <v-card width="800px">
      <v-toolbar color="primary white--text" flat>
        <v-toolbar-title>Datos de la Factura Electronica.</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text class="py-2">
        <v-row>
          <v-col cols="7">
            <v-combobox
              v-model="filtroestudiante"
              :items="clientes"
              label="* Cliente"
              :loading="isloadingestudent"
              loader-height="4"
              placeholder="tecla enter para buscar..."
              prepend-inner-icon="mdi-account"
              return-object
              hide-details
              outlined
              dense
            ></v-combobox>

            <v-btn small tile dark @click="$refs.clientereg.openmodal()">Registrar nuevo cliente</v-btn>
          </v-col>
          <!-- <v-col cols="6">
              <v-select :items="documentos" label="Tipo documento" return-object hide-details dense outlined></v-select>
            </v-col> -->

          <v-col cols="5">
            <v-text-field
              v-model.trim="factura.numeroDocumentoCliente"
              label="Numero Documento Cliente"
              type="text"
              outlined
              readonly
              color="green"
              prepend-inner-icon="mdi-badge-account-horizontal-outline"
              hide-details
              dense
            />
          </v-col>

          <v-col cols="12">
            <v-text-field
              v-model.trim="factura.email"
              label="Correo para enviar la factura:"
              prepend-inner-icon="mdi-email"
              type="text"
              outlined
              hide-details
              dense
            />

            <v-checkbox
              v-model="isSendCorreo"
              label="Enviar correo automaticamente."
              class="ma-0 pa-0"
              dense
              hide-details
            />
          </v-col>

          <v-col class="my-0 py-0" v-if="msgnitinvalido">
            <small class="mb-0 pb-0 ml-2 red--text"> <b>AVISO:</b> {{ msgnitinvalido }} </small>
          </v-col>

          <v-col cols="12" v-if="isSignifEvento && is567(eventoSigActivo)">
            <div>
              <v-divider class="mb-0 pb-0"></v-divider>
              <v-radio-group v-model="factura.online" label="Tipo de emision:" class="mt-1" hide-details row>
                <v-radio label="Normal" :value="true"></v-radio>
                <v-radio label="Regularizacion" :value="false"></v-radio>
              </v-radio-group>
            </div>
          </v-col>

          <v-col cols="12" v-if="isSignifEvento && is567(eventoSigActivo) && !factura.online">
            <small class="green--text"><span> El Ev. significativo requiere los siguientes datos: </span></small>

            <v-row no-gutters>
              <v-col cols="5">
                <v-text-field
                  v-model.number="factura.numeroFactura"
                  label="* Nro. factura"
                  class="mr-2"
                  type="number"
                  outlined
                  hide-details
                  dense
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="fecha_factura"
                  label="* Fecha"
                  type="date"
                  class="mr-2"
                  outlined
                  hide-details
                  dense
                />
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="hora_factura" label="* Hora" type="time" outlined hide-details dense />
              </v-col>
            </v-row> 
          </v-col>

          <v-col cols="12" v-show="showSector" class="pt-0">
            <small class="green--text"><span> Seleccione la actividad para verificar un cafc activo: </span></small>
            <v-row no-gutters>
              <v-col cols="12" sm="4" md="6">
                <v-select
                  v-model="docsector"
                  :items="docssector"
                  label="Documento Sector (cafc)"
                  :disabled="loadingactividades || !docsector_activo"
                  prepend-inner-icon="mdi-book-outline"
                  item-value="id"
                  class="mt-2"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <p class="mb-0">
              <b>Codigo Punto:</b> <span v-if="puntoventa">{{ puntoventa.codigo_punto_venta }}</span>
            </p>
            <p><b>Codigo sucursal:</b> {{ factura.codigoSucursal }}</p>
            <p class="mb-0">
              <b>Evento Masivo:</b> {{ isMasivoEvento ? 'SI' : 'NO' }}
              <v-progress-linear indeterminate v-if="loadingVerifMasivo" height="1" />
            </p>
            <p class="mb-0">
              <b>Evento Significativo:</b> {{ isSignifEvento ? 'SI' : 'NO' }}
              <v-progress-linear indeterminate v-if="loadingVerifMasivo" height="1" />
            </p>
            <div v-if="isSignifEvento">
              <p class="mb-0 ml-4">
                <small><b>Desc:</b> [{{ eventoSigActivo.codigo }}] {{ eventoSigActivo.descripcion }}</small> (<small>
                  {{ parseFecha(eventoSigActivo.fecha_inicio) }}
                </small>
                - <small> {{ parseFecha(eventoSigActivo.fecha_fin) }} </small>)
              </p>
            </div>
            <p class="mb-0" v-if="loadingCafActivo">
              <b>cafc...:</b>
              <v-progress-linear indeterminate height="1" />
            </p>
          </v-col>
        </v-row>

        <v-progress-linear indeterminate v-if="loading || loadingcodigoMetodoPago" />
        <p class="text-center red--text">{{ msg }} </p>
      </v-card-text>
      <v-divider class="my-0"></v-divider>

      <v-card-actions v-if="params.showfooter">
        <v-spacer></v-spacer>
        <v-btn class="ma-2" color="success" rounded @click="save()" :disabled="loadingVerifSig || loading">
          <v-icon class="mx-1">mdi-content-save</v-icon> Guardar
        </v-btn>
        <v-btn color="blue darken-1" outlined rounded @click="$emit('onclose')">
          Cancelar <v-icon> mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

    <ClienteReg ref="clientereg" v-on:newregcliente="onnewregcliente" />
  </v-row>
</template>

<script>
  import xaxios from '@/xaxios';
  import axios from 'axios';
  import ClienteReg from '@/views/recibos/clientes/registrar.vue';
  import { getAccessToken } from '@/accessToken';
  export default {
    data() {
      return {
        dialog: false,
        filtroestudiante: '',
        showSector: false,
        msgnitinvalido: '',
        xisOnline: true,
        loadingonline: false,
        isloadingestudent: false,
        loadingpuntos: false,
        loading: false,
        loadingcodigoMetodoPago: false,
        loadingVerifMasivo: false,
        loadingVerifSig: false,
        loadingCafActivo: false,
        isMasivoEvento: false,
        isSignifEvento: false,
        cafcActivo: null,
        eventoSigActivo: null,
        timeoutHnd: 0,
        documentos: [],
        statusconceptos: [],
        clientes: [],
        puntosventas: [],
        msg: '',
        xsucursal: null,
        puntoventa: null,
        xrecibo: null,
        isSendCorreo: true,
        /*  */
        factura: {
          documentoOrigen: null,
          cafc: '', //vacio
          online: true,
          codigoDocumentoSector: 11, // 11
          codigoExcepcion: 0, // 0
          codigoMetodoPago: 0, // forma_pago_id(efectivo, transferencia) consultar el endpoint: http://localhost:8090/api/v1/esam/formaspagos/{id}
          codigoMoneda: 1, // 1 bolivianos
          descuentoAdicional: 0, // 0 por defecto
          noFacturables: [],
          detalleVenta: [
            {
              actividadEconomica: 'string', // por defecto 853000
              cantidad: 0, // 1 por defecto
              codigo: 'string', // consultar al endpoint mandar conceto_id: http://localhost:8090/api/v1/esam/conceptospagos/{id}
              codigoDocumentoSector: 'string', // 11
              codigoSin: '', // consultar al endpoint mandar conceto_id: http://localhost:8090/api/v1/esam/conceptospagos/{id}
              codigoUnidad: 'string', // consultar al endpoint mandar conceto_id: http://localhost:8090/api/v1/esam/conceptospagos/{id}
              descripcion: 'string', // consultar al endpoint mandar conceto_id: http://localhost:8090/api/v1/esam/conceptospagos/{id}
              montoDescuento: 0, // 0
              numeroImei: 0,
              numeroSerie: 0,
              precio: 0, // monto recibo
              subTotal: 0, // cantidad * precio
              unidadDescripcion: '',
            },
          ],
          email: '', // por el usuario
          codigoPuntoVenta: null, // 0 por defecto
          codigoSucursal: 0, // nro_sucursal, enviar codigosucursal al endpoint: http://localhost:8090/api/v1/esam/sucursales/{id}
          leyenda:
            'Ley Nro. 453: Esta prohibido importar, distribuir o comercializar productos expirados o prontos a expirar.',
          montoGiftCard: 0, // 0
          montoSujetoIva: 0, // por defecto monto total que se paga
          montoTotal: 0,
          montoTotalMoneda: 0, // por defecto monto total que se paga
          nombreEstudiante: 'string',
          numeroDocumentoCliente: '',
          numeroFactura: null,
          fechaHora: null,
          numeroTarjeta: 0, // 0 por defecto
          periodoFacturado: 'string', // fecha_prevista de pago del primer cuotas
          tipoCambio: 1, // 1 por defecto
          tipoEmision: 1, // 1 por defecto
          tipoFactura: 1, // 1 por defecto
          usuario: 'string', // el logueado
          // nuevo
          cliente: {
            complemento: 'string',
            estado: 1,
            id: 0,
            numeroDocumento: 'string',
            razonSocial: 'string',
            tipoDocumento: 'string',
          },
        },
        fecha_factura: null,
        hora_factura: null,
        params: {
          showfooter: true,
        },
        xloadstatusconceptos: 0,
        loadingactividades: false,
        uactividades: [],
        docssector: [
          { id: 1, text: 'COMPRA Y VENTA' },
          { id: 11, text: 'SECTOR EDUCATIVO' },
          { id: 46, text: 'SECTOR EDUCATIVO ZONA FRANCA' },
        ],
        docsector: null,
        docsector_activo: true,
        actividad: null,
        leyendas: [],
        apikeytoken: '',
        xprograma:null,
      };
    },
    components: { ClienteReg },
    watch: {
      filtroestudiante: function() {
        this.documentSector();
        if (typeof this.filtroestudiante != 'string') {
          //window.console.log('filtroestudiante:', this.filtroestudiante);
          if (!this.filtroestudiante) return;
          this.factura.numeroDocumentoCliente = this.filtroestudiante.numero_documento;
          this.factura.email = this.filtroestudiante.email;
          this.factura.cliente.complemento = this.filtroestudiante.complemento;
          this.factura.cliente.id = this.filtroestudiante.id;
          this.factura.cliente.numeroDocumento = this.filtroestudiante.numero_documento;
          this.factura.cliente.razonSocial = (this.filtroestudiante.razon_social + '').trim().toUpperCase();
          // this.factura.cliente.tipoDocumento = this.filtroestudiante.tipo_documento_id;
          this.factura.cliente.tipoDocumento = this.filtroestudiante.tipo_documento.codigo_clasificador_SIN;
          if (this.filtroestudiante.is_verificado) this.factura.codigoExcepcion = 0;
          else this.factura.codigoExcepcion = 1;

          let numd = this.factura.cliente.numeroDocumento;
          let defecto = numd == '99001' || numd == '99002' || numd == '99003';
          if (defecto) {
            this.msgnitinvalido = `Casos especiales normas impuestos.`;
          } else if (!this.filtroestudiante.is_verificado && this.filtroestudiante.tipo_documento_id == 2) {
            this.msgnitinvalido = `El NIT (${this.filtroestudiante.numero_documento}) no esta verificado`;
          } else this.msgnitinvalido = '';

          //window.console.log(JSON.stringify(this.factura, null, 4));
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function() {
          if (vue.filtroestudiante && vue.filtroestudiante.length > 2) {
            vue.getclientes();
          } else {
            vue.msg = '';
          }
          this.timeoutHnd = 0;
        }, 500);
      },
      loadingcodigoMetodoPago: function() {
        if (!this.loadingcodigoMetodoPago) this.msg = '';
      },
      actividad: function(a) {
        if (!this.actividad) return;
        this.docsector = null;
        if (a.codigo == '620200') this.docsector = 1;
        else if (a.codigo == '853000') this.docsector = 11;
        else this.docsector = 46; // zona franca, no se sabe si deb iba or defecto
      },
      docsector() {
        if (this.docsector) {
          this.verificarCafcActivo(this.docsector);
        }
      },
      puntoventa: function() {
        if (this.puntoventa) this.factura.codigoPuntoVenta = this.puntoventa.codigo_punto_venta;
      },
      fecha_factura: function() {
        if (!this.fecha_factura) return;
        this.parseFechaHora();
      },
      hora_factura: function() {
        if (!this.hora_factura) return;
        this.parseFechaHora();
      },
      'factura.online': function() {
        if (!this.factura.online) {
          this.factura.numeroFactura = null;
          this.factura.fechaHora = null;
          this.fecha_factura = null;
          this.hora_factura = null;
        }
      },
    }, 
    methods: {
      async showThisView(recibo, estudiante, sucursal, clearcliente, programa) {
        window.console.log('>>>>showThisView emitfacturaE..\n', recibo, estudiante, sucursal, clearcliente,programa);
        this.xsucursal = sucursal;
        this.xprograma = programa;
        this.xrecibo = recibo;
        this.showSector = false;
        this.loading = true;
        this.noFacturables = [];
        let user = this.$store.state.DATA_USER;
        if (!user.seg_apellido) user.seg_apellido = '';
        if (!estudiante.seg_apellido) estudiante.seg_apellido = '';
        /* this.factura.montoSujetoIva = recibo.total;
        this.factura.montoTotal = recibo.total;
        this.factura.montoTotalMoneda = recibo.total; */
        this.factura.montoSujetoIva = parseFloat(recibo.total.toFixed(2));
        this.factura.montoTotal = parseFloat(recibo.total.toFixed(2));
        this.factura.montoTotalMoneda = parseFloat(recibo.total.toFixed(2));
        this.factura.usuario = `${user.nombres} ${user.pri_apellido} ${user.seg_apellido}`;
        this.factura.detalleVenta = [];
        this.factura.nombreEstudiante = `${estudiante.nombres} ${estudiante.pri_apellido} ${estudiante.seg_apellido}`;
        this.factura.codigoSucursal = sucursal.numero_sucursal;
        this.factura.documentoOrigen = '' + recibo.id;
        if (clearcliente) {
          this.factura.codigoPuntoVenta = null;
          this.filtroestudiante = null;
          this.factura.numeroDocumentoCliente = '';
          this.factura.online = true;
          this.factura.email = '';
          this.puntoventa = null;
          this.msgnitinvalido = '';
          this.factura.cafc = '';
          //this.factura.documentoOrigen = null;
          this.factura.numeroFactura = null;
          this.factura.fechaHora = null;
          this.fecha_factura = null;
          this.hora_factura = null;
          this.actividad = null;
          this.docsector = null;
          await this.obtenerToknFactura(sucursal.id);
          this.getPuntosVentaBySucursal(sucursal);
          this.getactividades();
          this.showSector = true;
        }
        this.loadingcodigoMetodoPago = false;
        this.loading = false;
        this.dialog = true;
        this.msg = '';
        const vue = this;
        this.statusconceptos = [];
        this.xloadstatusconceptos = 0;
        recibo.detalle.forEach((x) => {
          let status = {
            concepto_id: x.id,
            concepto_name: x.concepto_name,
            msg: null,
            status: null,
          };
          if (!x.facturable) vue.noFacturables.push(x);
          vue.statusconceptos.push(status);
        });
        let xtotales = 0;
        recibo.detalle.forEach((d, index) => {
          window.console.log("recibo d:",d);
          if (index == 0) {
            if (d.fecha_de_pagar) {
              let fs = d.fecha_de_pagar.split('-');
              let mes = fs[1];
              vue.factura.periodoFacturado = vue.getmesstr(mes);
            } else {
              let datex = new Date().getMonth() + 1;
              vue.factura.periodoFacturado = vue.getmesstr(datex);
            }
          }
          let item = { cantidad: d.cantidad };

          //item.cantidad = 1;
          if (!item.cantidad) item.cantidad = 1;
          if (vue.factura.codigoDocumentoSector) item.codigoDocumentoSector = vue.factura.codigoDocumentoSector;
          else item.codigoDocumentoSector = '11';
          let sector = '';
          /*if (item.codigoDocumentoSector == '1') sector = '620200';
          else if (item.codigoDocumentoSector == '11') sector = '853000';*/
          sector = '853000';
          item.actividadEconomica = sector;

          item.codigo = '----';
          item.codigoSin = '----';
          item.codigoUnidad = d.unidad_medida_codigoSIN;
          item.descripcion = d.nombre_concepto;
          item.montoDescuento = 0;
          //item.precio = d.importe - d.saldo;
          item.numeroImei = 0;
          item.numeroSerie = 0;
          item.precio = d.monto;
          item.subTotal = item.cantidad * item.precio;
          xtotales += item.subTotal;
          vue.getconceptopago(d, item);
          vue.factura.detalleVenta.push(item);
        });
        /* this.factura.montoTotal = xtotales;
        this.factura.montoTotalMoneda = xtotales;
        this.factura.montoSujetoIva = xtotales; */
        this.factura.montoTotal = parseFloat(xtotales.toFixed(2));
        this.factura.montoTotalMoneda = parseFloat(xtotales.toFixed(2));
        this.factura.montoSujetoIva = parseFloat(xtotales.toFixed(2));
        window.console.log('PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP',this.factura);
        this.getformapago(recibo.forma_pago_id);
        this.getdocumentos();
        this.getclientes();
        this.documentSector();
        // window.console.log('recibo fact::', recibo);
        // window.console.log(JSON.stringify(this.factura, null, 4));
      },
      getconceptopago(concepto, item) { 
        let siesam = true;
        let vue = this;
        let config = {};
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        if(siesam){
          config = {
            method: 'get', 
            // url: `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptospagos/${concepto.concepto_pago_id}`,
            // url: `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/conceptopago/${concepto.concepto_pago_id}/unidadnegocio/${unidad}`,
            url: `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptopagounidadnegocio/conceptopago/${concepto.concepto_pago_id}/unidadnegocio/${unidad}/nit/${this.xsucursal.nit_id}`,
            headers: {
              'Content-Type': 'application/json',
            },
          };
        }else{ 
          config = {
            method: 'get',
            url: `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptospagos/${concepto.concepto_pago_id}`,
            headers: {
              'Content-Type': 'application/json',
            },
          };
        }
        

        xaxios.request(config)
          .then(function(response) {
            let stado = vue.statusconceptos.find((x) => x.concepto_id == concepto.concepto_id);
            if (!stado) stado = vue.statusconceptos.find((x) => x.concepto_id == concepto.id);
            if (stado) stado.status = 'ok';
            let data = response.data;
            if(data.data) data = data.data;
            window.console.log('statusconceptos::', concepto, data,vue.statusconceptos);
            item.codigo = data.id;
            if(!item.codigo) item.codigo = concepto.concepto_pago_id;
            item.codigoSin = ""+data.codigo_sin; // debe ser string para cca tarija 
            //item.codigoUnidad = data.codigo_sin;
            //item.codigoUnidad = '' + data.unidad_medida.codigo_SIN; 
            item.codigoUnidad = '' + concepto.unidad_medida_codigoSIN;
            if(!data.descripcion) data.descripcion = '';
            item.descripcion = vue.xprograma.nombre_compuesto +': ' +data.descripcion;
            if(unidad==6) item.descripcion = data.concepto_pago.nombre
            
            item.xcodigo_actividad = data.codigo_actividad;
            if(!item.xcodigo_actividad) item.xcodigo_actividad = data.actividad_economica_sin;
            if(data.concepto_pago && data.concepto_pago.unidad_medida) item.unidadDescripcion = data.concepto_pago.unidad_medida.descripcion_SIN;
            else item.unidadDescripcion = data.descripcion_cuenta_contable;
            //item.xconcepto_name = concepto.concepto_name;
            //window.console.log('getconceptopago:', response.data, concepto);
            window.console.log('getconceptopago item:', item);
            if (!item.codigoSin) { 
              //vue.msg += `Falta el codigoSin del concepto ${concepto.concepto_name}.`;
              if (stado) stado.msg = `Falta el codigoSin del concepto ${concepto.concepto_name}.`;
            }
            //vue.factura.detalleVenta.push(item);
            vue.xloadstatusconceptos += 1;
            vue.isLoadAllConceptos();
          })
          .catch(function(error) {
            window.console.log('ERRRORRRR',error, error.response,vue.statusconceptos,concepto);
            let stado = vue.statusconceptos.find((x) => x.concepto_id == concepto.concepto_id);
            if (!stado) stado = vue.statusconceptos.find((x) => x.concepto_id == concepto.id);
            if (stado) stado.status = 'bad';
            if(error.response){
              let data = error.response.data.error;
              if (stado) stado.msg = data; 
              window.console.log('ERRRORRRR item:', data,stado);
            }
            vue.xloadstatusconceptos += 1;
            vue.isLoadAllConceptos();
            //vue.factura.detalleVenta.push(item);
          });
      },
      isLoadAllConceptos() {
        let tam = this.statusconceptos.length;
        if (this.xloadstatusconceptos >= tam) {
          this.$emit('xloadstatusconceptos');
        }
      },
      setLoadPuntosBySucursal(idsucursal, sucursal) {
        this.getPuntosVentaBySucursal(sucursal);
        this.factura.codigoSucursal = sucursal.numero_sucursal;
        this.nothing = idsucursal;
      },
      setLoadingFromRecbos(loading) {
        this.loading = loading;
      },
      setParametros(parametros) {
        if (parametros) {
          this.params.showfooter = parametros.showfooter;
        }
      },
      parseFechaHora() {
        // 2022-05-31T17:34:32.597
        let fechita = `${this.fecha_factura}T${this.hora_factura}:00.000`;
        let evfecha = new Date(this.eventoSigActivo.fecha_inicio);
        let fafecha = new Date(fechita);
        this.factura.fechaHora = fechita;
        if (fafecha.getTime() <= evfecha.getTime()) {
          this.msg = 'Fecha de factura no puede ser menor a la fecha de inicio del evento significativo.';
        }
        window.console.log('>>>', fechita, this.eventoSigActivo.fecha_inicio, '\n', evfecha, fafecha);
      },
      parseFecha(f) {
        if (!f) return '';
        let fs = f.split('T');
        let tz = fs[0].split('-');
        let ts = fs[1].split(':');
        return `${tz[2]}/${tz[1]}/${tz[0]} ${ts[0]}:${ts[1]}`;
      },
      getmesstr(mes) {
        // esto corrige el error, pero no se estaria bien la facturacion
        // conceptos opcionales como compra venta
        /*if (!mes) {
          let date = new Date();
          mes = date.getMonth() + 1;
        }*/
        if (mes == 1) return 'ENERO';
        else if (mes == 2) return 'FEBRERO';
        else if (mes == 3) return 'MARZO';
        else if (mes == 4) return 'ABRIL';
        else if (mes == 5) return 'MAYO';
        else if (mes == 6) return 'JUNIO';
        else if (mes == 7) return 'JULIO';
        else if (mes == 8) return 'AGOSTO';
        else if (mes == 9) return 'SEPTIEMBRE';
        else if (mes == 10) return 'OCTUBRE';
        else if (mes == 11) return 'NOVIEMBRE';
        else if (mes == 12) return 'DICIEMBRE';
      },
      getdocumentos() {
        const vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/tiposdocumentos`,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            //window.console.log(JSON.stringify(response.data));
            let data = response.data.data;
            data.map((x) => {
              x.text = `${x.descripcion_SIN} (${x.codigo_clasificador_SIN})`;
            });
            vue.documentos = data;
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },
      getclientes() {
        const vue = this;
        vue.isloadingestudent = true;
        var config = {
          method: 'get',
          //url: '${process.env.VUE_APP_API_REST}/api/v1/esam/clientes',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/clientes?numero_documento=${this.filtroestudiante}&razon_social=${this.filtroestudiante}`,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.map((x) => {
              x.text = `${x.razon_social} (${x.numero_documento})`;
            });
            vue.clientes = data;
            //window.console.log(data);
            vue.isloadingestudent = false;
          })
          .catch(function(error) {
            vue.isloadingestudent = false;
            window.console.log(error);
          });
      },
      getformapago(idforma) {
        window.console.log('----------------------------------', idforma);
        const vue = this;
        this.loadingcodigoMetodoPago = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/formaspagos/${idforma}`,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            vue.factura.codigoMetodoPago = data.codigo_clasificador_SIN;
            //window.console.log('formapago:', data);
            vue.loadingcodigoMetodoPago = false;
            vue.msg = '';
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingcodigoMetodoPago = false;
          });
      },
      async getPuntosVentaBySucursal(sucursal) {
        let sedeid = this.$store.state.CARGO.sede.id;
        window.console.log('getPuntosVentaBySucursal', sucursal, 'sedeid', sedeid);
        await this.obtenerToknFactura(sucursal.id);
        this.getactividades();
        let vue = this;
        this.puntosventas = [];
        this.puntoventa = null;
        this.isMasivoEvento = false;
        this.isSignifEvento = false;
        this.cafcActivo = null;
        this.eventoSigActivo = null;
        vue.loadingpuntos = true;
        var config = {
          method: 'get',
          //url: `${process.env.VUE_APP_API_REST}/api/v1/esam/puntosventas?sucursalId=${sucursal.id}`,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales/sucursal/${sucursal.id}/sede/${sedeid}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('puntos venta:', data);
            vue.puntosventas = [];
            vue.puntoventa = data.punto_venta;
            vue.puntosventas.push(vue.puntoventa);
            vue.loadingpuntos = false;
            vue.verificarIfExistMasivo(vue.puntoventa, sucursal);
            vue.verificarIfExistSig(vue.puntoventa, sucursal);

            //vue.verificarCafcActivo(vue.puntoventa, sucursal);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingpuntos = false;
          });
      },
      onnewregcliente(nuevo) {
        nuevo.text = `${nuevo.razon_social} (${nuevo.numero_documento})`;
        this.clientes.push(nuevo);
        this.filtroestudiante = nuevo;
        window.console.log('>>>>>> ', nuevo, this.filtroestudiante, this.clientes);
      },
      isValido() {
        this.msg = '';
        let vue = this;
        if (!this.isSignifEvento) {
          this.factura.cafc = null;
        }
        if (!this.is567(this.eventoSigActivo)) {
          this.factura.cafc = null;
        }
        //window.console.log(this.cafcActivo, this.isSignifEvento, this.is567(this.eventoSigActivo));
        //window.console.log('FACTURA:', JSON.stringify(this.factura, null, 4));
        if (!this.cafcActivo && this.isSignifEvento && this.is567(this.eventoSigActivo))
          this.msg = 'El evento significativo requiere un CAFC activo.';
        if (this.loadingCafActivo) this.msg = 'Obteniendo CAFC, espere un momento...';
        if (this.loadingcodigoMetodoPago) this.msg = 'Obteniendo el codigo Metodo Pago, espere un momento...';
        if (this.loadingVerifMasivo) this.msg = 'Verificando eventos masivos, espere un momento...';
        if (this.factura.codigoPuntoVenta == null) this.msg = 'No hay punto de venta.';
        if (!this.factura.codigoMetodoPago) this.msg = 'no se pudo obtener el codigoMetodoPago (formaPago).';
        if (!this.factura.email) this.msg = 'Ingrese el email.';
        if (!this.factura.numeroDocumentoCliente) this.msg = 'Debe seleccionar un cliente.';
        // if (!this.factura.email.includes('@')) this.msg = 'el formato del email no es el correcto.';
        if (this.eventoSigActivo && this.is567(this.eventoSigActivo) && !this.factura.online) {
          if (!this.factura.numeroFactura) this.msg = 'El ev. Significativo solicita un numero de factura valido.';
          if (!this.fecha_factura) this.msg = 'El ev. Significativo solicita fecha y hora validos.';
          if (!this.hora_factura) this.msg = 'El ev. Significativo solicita fecha y hora validos.';
          // if (!this.factura.online) this.msg = 'Debe especificar el tipo de facturacion.';
          let evfecha = new Date(this.eventoSigActivo.fecha_inicio);
          let fafecha = new Date(this.factura.fechaHora);
          if (fafecha.getTime() <= evfecha.getTime()) {
            this.msg = 'Fecha de factura no puede ser menor a la fecha de inicio del evento significativo.';
          }
        }
        // escorrecto, el problema esque no se llena el detalle hasta despues de generar el recibo.
        /*this.factura.detalleVenta.forEach((x) => {
          if (!x.codigoSin) {
            vue.msg = `Falta el codigoSin del concepto: ${x.xconcepto_name}`;
          }
        });*/
        this.statusconceptos.forEach((x) => {
          if (x.msg) {
            //vue.msg = `Obteniendo concepto SIN: ${x.concepto_name},  espere un momento...`;
            vue.msg = x.msg;
          }
        });
        if (this.noFacturables && this.noFacturables.length > 0) {
          this.msg = 'Existen conceptos que no son facturables';
        }
        if (this.msg) return false;
        return true;
      },
      async save() {
        // window.console.log(JSON.stringify(this.factura, null, 4));
        let valido = this.isValido();
        if (!valido) return;

        if (!this.factura.documentoOrigen) {
          this.msg = 'Error, No se pudo obtener el numero de recibo.';
          return;
        }

        // window.console.log(JSON.stringify(this.factura, null, 4));

        if (await this.$root.$confirm.open('Emitir Factura', 'Estas seguro?', { color: 'red' })) {
          this.emitirfactura();
        }
      },
      verificarIfExistMasivo(punto, sucursal) {
        window.console.log('verificarIfExistMasivo', punto, sucursal);
        let vue = this;
        vue.loadingVerifMasivo = true;
        let codSucursal = sucursal.numero_sucursal;
        let codPunto = punto.codigo_punto_venta;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventomasivo/existeActivo/sucursal/${codSucursal}/puntoventa/${codPunto}`,
          headers: {
            // apikey: this.$store.getters.getApiKey,
            apikey: this.apikeytoken,
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('verificarIfExistMasivo:', data);
            vue.isMasivoEvento = data.isExiste;
            vue.loadingVerifMasivo = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingVerifMasivo = false;
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log('ERROR MASIVO',data);
            if (mensaje || data.detalles) vue.msg = `Error ${mensaje}`;
            else if(data[0].codigo && data[0].descripcion)
              vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;
            // else vue.msg = `no se pudo verificar si hay evento sig.`;
            else vue.msg = ``;
          });
      },
      verificarIfExistSig(punto, sucursal) {
        //window.console.log('verificarIfExistSig', punto, sucursal);
        let vue = this;
        vue.loadingVerifSig = true;
        this.eventoSigActivo = null;
        let codSucursal = sucursal.numero_sucursal;
        let codPunto = punto.codigo_punto_venta;
        var config = {
          method: 'get',
          ///facturacion/eventosignificativo/existeActivo/sucursal/{codSuc}/puntoventa/{codPv}
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventosignificativo/existeActivo/sucursal/${codSucursal}/puntoventa/${codPunto}`,
          headers: {
            // apikey: this.$store.getters.getApiKey,
            apikey: this.apikeytoken,
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            //window.console.log('verificarIfExistSig:', data);
            vue.eventoSigActivo = data;
            vue.isSignifEvento = data.id ? true : false;
            vue.loadingVerifSig = false;
            if (!vue.is567(vue.eventoSigActivo)) {
              vue.factura.cafc = null;
            }
            // vue.definirLeyenda();
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingVerifSig = false;
            let data = error.response.data;
            let mensaje = data.mensaje;
            //window.console.log('datita', data);
            if (mensaje || data.detalles) vue.msg = `${mensaje}`;
            else if(data[0].codigo && data[0].descripcion) vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;
            // else vue.msg = `no se verifico si hay evento sig.`;
            else vue.msg = '';
            if (vue.msg == 'No existe Evento Significativo Activo') vue.msg = '';
          });
      },
      async verificarCafcActivo(numeroDocumentoSector) {
        /* this.factura.codigoDocumentoSector = numeroDocumentoSector;
        let a = 2;
        if(a > 1 ) return; */
        // window.console.log('verificarCafcActivo', numeroDocumentoSector);
        // yyyyMMddHHmmssSSS
        let xapikey = this.apikeytoken;
        if (!xapikey) xapikey = this.$store.getters.getApiKey;
        let vue = this;
        vue.loadingCafActivo = true;
        vue.cafcActivo = null;
        //this.getLeyendas(numeroDocumentoSector);
        this.verificarOnline();
        this.factura.codigoDocumentoSector = numeroDocumentoSector;
        let act = '853000';
        //if (numeroDocumentoSector == 1) act = '620200';
        if (this.factura.detalleVenta) {
          this.factura.detalleVenta.forEach((x) => {
            x.actividadEconomica = act;
            x.codigoDocumentoSector = '' + numeroDocumentoSector;
          });
        }
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/cafcs/buscarActivo/${numeroDocumentoSector}`,
          headers: {
            // apikey: this.$store.getters.getApiKey,
            apikey: xapikey,
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('verificarCafcActivo:', data);
            vue.cafcActivo = data;
            vue.factura.cafc = data.codigo;
            //ue.isSignifEvento = data.isExiste;
            /*if (vue.is567(vue.eventoSigActivo)) {
              vue.factura.cafc = data.codigo;
            } else {
              vue.factura.cafc = null;
            }*/
            vue.loadingCafActivo = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingCafActivo = false;
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data);
            if (vue.isSignifEvento && vue.is567(vue.eventoSigActivo)) {
              if (mensaje || data.detalles) vue.msg = `Error ${mensaje}`;
              else vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;
            }
          });
      },
      is567(evento) {
        if (!evento) return false;
        let code = evento.codigo;
        if (code == '5' || code == '6' || code == '7') return true;
        return false;
      },
      documentSector(){
        this.docsector_activo = true;
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        if(unidad != 10 ){ // !dbs
          this.docssector = this.docssector.filter(x=>x.id != 46)
        }else{
          this.docssector = this.docssector.filter(x=>x.id != 46)
          this.docssector.push( { id: 46, text: 'SECTOR EDUCATIVO ZONA FRANCA' } );
        }
        if(unidad==6){ //siesam
          this.docsector = this.docssector[0].id;
          this.factura.codigoDocumentoSector = 1;
          setTimeout(()=>{
            this.docsector_activo = false;
          },300)
        }
      },
      getactividades() {
        this.loadingactividades = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/actividad`,
          headers: {
            // apikey: this.$store.getters.getApiKey,
            apikey: this.apikeytoken,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data.map((u) => {
              u.id = u.codigo;
              u.text = `(${u.codigo}) ${u.descripcion}`;
            });
            vue.uactividades = data;
            vue.loadingactividades = false;
            let defecto = data.find((x) => x.codigo == '853000');
            vue.actividad = defecto;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingactividades = false;
          });
      },
      async obtenerToknFactura(idsuc) {
        // let idsuc = this.$route.query.idsucursal;
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });
        this.apikeytoken = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsuc}`)
          .then(({ data }) => (data.apikey ? data.apikey : ''));

        /* window.console.log('TOKENNNNNNNNNNN::--------------------------');
        window.console.log('>>>> ', this.$store.getters.getApiKey);
        window.console.log('>>>> ', this.apikeytoken); */
      },
      emitirfactura() {
        if(this.loading) return;
        this.loading = true;
        let url = '';
        const siesam = true;
        const xfacturar = JSON.parse(JSON.stringify(this.factura));
        if (xfacturar.codigoDocumentoSector == 11 || xfacturar.codigoDocumentoSector == 46) {
          url = `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/sectorEducativo/cliente`;
        } else {
          url = `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/sectorCompraVenta/cliente`;
        }
        window.console.log('<><><><><>',xfacturar.codigoDocumentoSector,url);
        let xapikey = this.apikeytoken;
        if(siesam){
          window.console.log(this.factura);
          //xapikey = "371082021"
          let detas = []
          this.factura.detalleVenta.forEach(x=>{
            let d = {
              "cantidad": x.cantidad,
              "codigoDocumentoSector": ""+this.factura.codigoDocumentoSector,
              "actividadEconomica": ""+x.xcodigo_actividad,
              "codigo": ""+x.codigo,
              "codigoSin": x.codigoSin,
              "codigoUnidad": ""+x.codigoUnidad,
              "descripcion": x.descripcion,
              "montoDescuento": x.montoDescuento,
              "numeroImei": 0,
              "numeroSerie": 0,
              "precio": x.precio,
              "subTotal": x.subTotal,
              "unidadDescripcion": x.unidadDescripcion
            }
            window.console.log("detaaaaa",x);
            detas.push(d);
          })

          url = `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/sectorEducativo/cliente`;
          const datafactura = {
            "documentoOrigen": ""+this.xrecibo.id,
            "cafc": this.factura.cafc,
            "online": this.factura.online,
            "codigoDocumentoSector": this.factura.codigoDocumentoSector,
            "codigoExcepcion": this.factura.codigoExcepcion,
            "codigoMetodoPago": this.factura.codigoMetodoPago,
            "codigoMoneda": this.factura.codigoMoneda,
            "descuentoAdicional": this.factura.descuentoAdicional,
            "noFacturables": [],
            "detalleVenta": detas,
            "email": this.factura.email,
            "codigoPuntoVenta": this.factura.codigoPuntoVenta,
            "codigoSucursal": this.factura.codigoSucursal,
            "leyenda": "---",
            "montoGiftCard": this.factura.montoGiftCard,
            "montoSujetoIva": this.docsector == 46? 0:this.factura.montoSujetoIva,
            "montoTotal": this.factura.montoTotal,
            "montoTotalMoneda": this.factura.montoTotalMoneda,
            "nombreEstudiante": this.factura.nombreEstudiante,
            "numeroDocumentoCliente": this.factura.numeroDocumentoCliente,
            "numeroFactura": this.factura.numeroFactura,
            "fechaHora": null,
            "numeroTarjeta": this.factura.numeroTarjeta,
            "periodoFacturado": this.factura.periodoFacturado,
            "tipoCambio": this.factura.tipoCambio,
            "tipoEmision": this.factura.tipoEmision,
            "tipoFactura": this.factura.tipoFactura,
            "usuario": this.factura.usuario,
            "cliente": {
                "complemento": this.factura.cliente.complemento,
                "estado": this.factura.cliente.estado,
                "id": this.factura.cliente.id,
                "numeroDocumento": this.factura.cliente.numeroDocumento,
                "razonSocial": this.factura.cliente.razonSocial,
                "tipoDocumento": this.factura.cliente.tipoDocumento
            }
          }
          this.factura = {...datafactura} 
        } 
        // window.console.log("this.factura.detalleVenta[0]",this.factura.detalleVenta[0]);
        if (this.factura.online) {
          if(!siesam) this.factura.cafc = null;
        }
        if (this.factura.cliente.tipoDocumento != 5) {
          this.factura.codigoExcepcion = 0;
        }
        let numd = this.factura.cliente.numeroDocumento;
        let defecto = numd == '99001' || numd == '99002' || numd == '99003';
        if (defecto) {
          this.factura.codigoExcepcion = 0;
        }

        if (this.isSendCorreo) this.factura.enviarCorreo = true;
        else this.factura.enviarCorreo = false;

        if (this.isMasivoEvento) url = `${process.env.VUE_APP_FACT_REST}/facturacion/ventas/masivo/cliente`;
        let vue = this;
        var config = {
          method: 'post',
          url: url,
          headers: {
            'Content-Type': 'application/json',
            // apikey: this.$store.getters.getApiKey,
            apikey: xapikey,
          },
          data: JSON.parse(JSON.stringify(this.factura)),
        };

        this.factura = xfacturar;

        window.console.log(JSON.stringify(config.data, null, 4));
        window.console.log('xsuc::::',this.xsucursal);
        /* let a = 2;
        if(a>1) return; */

        xaxios.request(config)
          .then(function(response) {
            window.console.log('emitirfactura: ', response);
            let data = response.data;
            if (data.mensaje) vue.msg = data.mensaje;
            else {
              if(data.data) data = data.data;
              vue.guardarFacturaenRecibo(data.venta.id, vue.xrecibo, data, vue.factura);
            }
            // vue.loading = false;
          })
          .catch(function(error) {
            window.console.log('error',error);

            vue.loading = false;
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data);
            if (mensaje || data.detalles) vue.msg = `Error ${mensaje}`;
            else vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;

            vue.$emit('onfacturafalled', vue.msg);
          });
      },
      getNumNit(){
        if(this.xsucursal && this.xsucursal.nit){
          return parseInt(this.xsucursal.nit)
        }
        return null;
      },
      guardarFacturaenRecibo(idfactura, recibo, xdata, factura) {
        window.console.log('guardarFacturaenRecibo: ',idfactura, recibo, xdata, factura,'---',this.xsucursal);
        let vue = this;
        let numeroFac = xdata.nroFactura;
        if(!numeroFac) numeroFac = xdata.venta.numeroFactura;
        if(!numeroFac) numeroFac = xdata.venta.nroFactura;
        var config = {
          method: 'put',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/recibo/addfactura`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            recibo_id: recibo.id,
            factura_id: idfactura,
            // numero_factura: xdata.venta.numeroFactura,
            // numero_factura: xdata.nroFactura,
            numero_factura: numeroFac,
            nit: vue.getNumNit()
          },
        };
        vue.loading = true;

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            vue.$emit('onfacturagenerada', idfactura, recibo, xdata, factura);
            window.console.log('guardarFacturaenRecibo: ', data);
            vue.loading = false;
          })
          .catch(function(error) {
            let data = error.response.data;
            window.console.log(data);
            vue.msg = `${JSON.stringify(data)}`;
            vue.loading = false;
          });
      },
      verificarOnline() {
        this.loadingonline = true;
        let xapikey = this.apikeytoken;
        if (!xapikey) xapikey = this.$store.getters.getApiKey;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/empresas/isonline`,
          headers: {
            'Content-Type': 'application/json',
            apikey: xapikey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('verificarOnline', data);
            if (data) {
              vue.xisOnline = data.isOnline;
            }
            vue.loadingonline = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingonline = false;
          });
      }, 
    },
    mounted() { 
      this.actividad = null;
      this.showSector = false;
      // this.getactividades();
    },
  };
</script>

<style></style>
